import { IndexableObject } from '../types/ObjectTypes';
import createChainablePropType, {
  ChainablePropType,
} from './createChainablePropType';

interface ColorPropsType extends IndexableObject {
  [key: string]: string;
}

export const isValidColorHex = (color: string): boolean =>
  /^#?[0-9A-Fa-f]{0,6}$/.test(color);

const color = (
  props: ColorPropsType,
  propName: string,
  componentName: string
): Error | null => {
  if (props[propName]) {
    const value: string = props[propName];
    if (!isValidColorHex(value)) {
      return new Error(
        `${componentName}: Invalid color value. Expected format RRGGBB, got "${value}".`
      );
    }
  }
  return null;
};

export const propType: ChainablePropType = createChainablePropType(
  color,
  'color'
);
